var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.932661,
    y: 0.932661,
    width: 27.0472,
    height: 27.0472,
    rx: 13.5236,
    stroke: "#9D9D9D",
    strokeWidth: 1.86532
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6547 9.63812C18.1396 9.63812 17.7221 9.22056 17.7221 8.70546V8.55002C17.7221 8.26143 17.6042 7.98467 17.3943 7.78061C17.1844 7.57655 16.8997 7.46191 16.6029 7.46191H13.2453C12.9485 7.46191 12.6638 7.57655 12.4539 7.78061C12.244 7.98467 12.1261 8.26143 12.1261 8.55002V8.70546C12.1261 9.22056 11.7085 9.63812 11.1934 9.63812H9.87218C9.57171 9.63812 9.32812 9.8817 9.32812 10.1822C9.32812 10.4826 9.57171 10.7262 9.87218 10.7262H9.88772C10.1968 10.7262 10.4473 10.9768 10.4473 11.2858V18.887C10.4473 19.3199 10.6242 19.735 10.939 20.0411C11.2539 20.3472 11.6809 20.5192 12.1261 20.5192H17.7221C18.1673 20.5192 18.5943 20.3472 18.9092 20.0411C19.224 19.735 19.4009 19.3199 19.4009 18.887V11.2858C19.4009 10.9768 19.6514 10.7262 19.9605 10.7262H19.976C20.2765 10.7262 20.5201 10.4826 20.5201 10.1822C20.5201 9.8817 20.2765 9.63812 19.976 9.63812H18.6547ZM14.3645 16.1512C14.3645 16.4603 14.114 16.7108 13.8049 16.7108C13.4958 16.7108 13.2453 16.4603 13.2453 16.1512V14.0061C13.2453 13.697 13.4958 13.4465 13.8049 13.4465C14.114 13.4465 14.3645 13.697 14.3645 14.0061V16.1512ZM16.6029 16.1512C16.6029 16.4603 16.3523 16.7108 16.0433 16.7108C15.7342 16.7108 15.4837 16.4603 15.4837 16.1512V14.0061C15.4837 13.697 15.7342 13.4465 16.0433 13.4465C16.3523 13.4465 16.6029 13.697 16.6029 14.0061V16.1512ZM16.6029 9.09407C16.6029 9.39454 16.3593 9.63812 16.0588 9.63812H13.7894C13.4889 9.63812 13.2453 9.39454 13.2453 9.09407C13.2453 8.7936 13.4889 8.55002 13.7894 8.55002H16.0588C16.3593 8.55002 16.6029 8.7936 16.6029 9.09407Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletbutton);
export default __webpack_public_path__ + "static/media/deletbutton.65ca365093805ae984b0ac00b06e8bf0.svg";
export { ForwardRef as ReactComponent };